import React from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import theme from "../../../../helpers/theme";
import {
  useMercoaSession,
  PayableDetails,
  PayableForm,
  PayableFormHeader,
  PayableCounterpartySearch,
  PayableOverview,
  PayableLineItems,
  PayablePaymentSource,
  PayableActions,
  PayableDocument,
  PayablePaymentDestination,
} from "@mercoa/react";
import StyledAlert from "../../../../components/generic/StyledAlert";
import Skeleton from "@mui/material/Skeleton";
import Button from "@mui/material/Button";

/**
 *
 * @param {string} invoiceId mercoa invoice ID
 * @returns embedded mercoa invoice details component for Payables
 */
const PayableInvoiceDetails = ({ invoiceId }) => {
  const session = useMercoaSession();

  const infoMessage =
    "Bank account information must be accurate in order to use an \
  account as a payable source.\
  Please contact your Arpari account manager if you need assisstance.";

  return (
    <Box
      sx={{
        overflowY: "auto",
        maxHeight: "99%",
      }}
    >
      <Box sx={{ margin: theme.dashboard.margins }}>

        <Button
          disableElevation
          size="small"
          type="submit"
          variant="outlined"
          color="primary"
          htmlType="submit"
          sx={{
            fontSize: 14,
            textTransform: "none",
            justifyItems: "flex-end",
            alignItems: "flex-end"
          }}
        >
          <Link
            to="/payables"
            color="primary"
          >
            Back
          </Link>
        </Button>
        <StyledAlert message={infoMessage} marginBottom="15px" marginTop={1} />
        {session?.entity && invoiceId && (
          <PayableDetails invoiceId={invoiceId}>
            {(props) => [
              <PayableDocument {...props} key={1} />,
              <PayableForm {...props} key={2}>
                {({ setSelectedVendor, selectedVendor }) => (
                  <>
                    <PayableFormHeader hideId />
                    <PayableCounterpartySearch
                      onSelect={setSelectedVendor}
                      counterparty={selectedVendor}
                    />
                    <PayableOverview />
                    <PayableLineItems />
                    <PayablePaymentSource />
                    <PayablePaymentDestination />
                    <PayableActions />
                  </>
                )}
              </PayableForm>,
            ]}
          </PayableDetails>
        )}
        {(!session?.entity || !invoiceId) && (
          <Skeleton variant="rounded" sx={{ width: "100%", height: "800px" }} />
        )}
      </Box>
    </Box>
  );
};

export default PayableInvoiceDetails;
